import apiGlobal from '../../../global/api.global';
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../';
import PopUp from 'Components/PopUp';
import { queryKeyes } from 'shared/queryKeys';
import EditFuelConsumerGroup from './EditGroup';
import { successToast } from 'Components/Toasts';
import DynamicGroupForm from './AddNewGroup';
import PopOver from 'Components/PopOver';
import ToolTip from 'Components/ToolTip';
import { queryClient } from 'react-query/queryClient';
import { isConfigurationButtonDisabled } from 'GenericForms/Helper';
import EditIcon from '../../../Media/ED2.png';
import Message from 'Components/Message';
import DeleteIcon from '../../../Media/delete.png';
import DisabledDeleteIcon from '../../../Media/delete_disabled.png';
import FormLoading from 'Components/FormLoading';
import { getConfigurationLimitsAction } from 'Store/Generic/ReportingSlice';
interface FuelConsumerType {
    refreshVesselMachineries?: number;
    setRefreshVesselMachineries?: (value: number) => void;
    activeSettingsTab?: number;
    refreshInnerTables?: boolean;
}

/**
 * FuelConsumer Component
 *
 * This component displays and manages a list of vessel machineries
 * that are fuel consumers. Users can:
 * - Add new fuel consumer groups.
 * - Edit existing fuel consumer groups.
 * - Delete existing fuel consumer groups.
 *
 * State Management:
 * - Handles UI states such as modals, tooltips, and popovers.
 * - Fetches and updates machinery data dynamically using React Query.
 */
const FuelConsumer = ({
    refreshVesselMachineries,
    setRefreshVesselMachineries,
}: FuelConsumerType) => {
    const { VesselID, Vessels, ConfigurationLimits, reportingLoading, reportingError } = useSelector((state: RootState) => state.Reporting);
    const vessel = Vessels.find((rec: any) => rec.id === VesselID);
    const [state, setState] = useState(false);
    const [editFuelConsumerGroup, setEditFuelConsumerGroup] = useState(false);
    const [selectedMachinery, setSelectedMachinery] = useState(null);
    const fcGroupURL = queryKeyes.vessel.MachinaryFuelGroup.url;
    const [deletePopOverState, setDeletePopOverState] = useState(false);
    const [openPopoverVesselMachinaryObject, setOpenPopoverVesselMachinaryObject] = useState<any | null>([]);
    const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);
    const [hoverId, setHoverId] = useState<string | null>(null);
    const [hoverEditId, setEditHoverId] = useState<string | null>(null);
    const [refreshForm, setRefreshForm] = useState(false);
    const vesselMachineriesList = ConfigurationLimits?.vessel_machinery_list || [];
    const machineryFuelGroup = ConfigurationLimits?.vessel_machinery_fc_group || [];
    const dispatch = useDispatch();
    /** Queries */
    /**
     * Fetches the list of vessel machineries for a given vessel.
     * This query is performed using React Query and utilizes caching.
     */
    /** Machinery fuel Group */

    /**
         * Deletes a specified fuel consumer group from the server.
         * @param obj - Object containing information about the group to delete.
         */
    const handleDelete = (obj: any) => {
        try {
            apiGlobal.delete(`/vessel_machinery_fc_group/${obj.id}/`, obj).then(async res => {
                if (res.status === 200 || res.status === 204) {
                    dispatch(getConfigurationLimitsAction(VesselID as number));
                    await queryClient.invalidateQueries(queryKeyes.vessel.ConfigurationList.key);
                    successToast('Group deleted successfully');
                    setOpenPopoverIndex(null);
                    setRefreshVesselMachineries(refreshVesselMachineries + 1);
                }
            })
        } catch (err) {
            console.error('Error:', err);
        }
    };
    return (
        <React.Fragment>
            {reportingLoading && <FormLoading />}
            {!reportingLoading &&
                <React.Fragment>
                    {/* Header with "Add New Group" Button */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="navbar_menu mb-0">Fuel Consumer Machinery List</h4>
                        <button
                            className="btn btn-primary waves-effect waves-light mb-1"
                            onClick={() => {
                                setState(true);
                                setDeletePopOverState(false)
                            }}
                            disabled={isConfigurationButtonDisabled(vessel)}
                        >
                            <i className="dripicons-plus font-size-16 align-middle me-2"></i>
                            New Group
                        </button>
                    </div>
                    {/* Add New Group Popup */}
                    <PopUp
                        state={state}
                        setState={setState}
                        body={
                            <DynamicGroupForm
                                VesselID={VesselID}
                                machineryList={vesselMachineriesList}
                                refreshState={state}
                                setRefreshState={setState}
                                isLoading={reportingLoading}
                                isError={reportingError}
                                groupURL={fcGroupURL}
                                refreshVesselMachineries={refreshVesselMachineries}
                                setRefreshVesselMachineries={setRefreshVesselMachineries}
                            />
                        }
                        title="Add New Fuel Consumer"
                        size="lg"
                    />
                    {/* Table of Vessel Machineries */}
                    <div className="table-responsive mb-3">
                        <table className="table" key={refreshVesselMachineries}>
                            <thead className="table-light">
                                <tr>
                                    <th className="p-2 align-middle sr-no-width">#</th>
                                    <th className='p-2 align-middle'>FC group name</th>
                                    <th className="p-2 align-middle">Machinery list</th>
                                    <th className="p-2 align-middle text-center w-20">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {machineryFuelGroup && machineryFuelGroup?.length > 0 ? (
                                    machineryFuelGroup.map((vesselMachinery: any, index: number) => (
                                        <tr key={vesselMachinery.id}>
                                            <td className='p-2 align-middle text-center'>{index + 1}</td>
                                            <td className="p-2 align-middle" >{vesselMachinery.vessel_machinery_fc_group_name}</td>
                                            <td className="p-0 align-middle">
                                                <table className="table m-0">
                                                    <tbody>
                                                        {vesselMachinery?.vessel_machinery_fc_names?.map((item: string) => (
                                                            <tr key={item}>
                                                                <td className="">{item}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td className="p-2 align-middle text-center">
                                                {/* Edit and Delete Buttons */}
                                                <div className="d-flex justify-content-center align-items-center flex-wrap">
                                                    <button
                                                        type="button"
                                                        className="btn mt-1 border-0"
                                                        disabled={isConfigurationButtonDisabled(vessel)}
                                                    >
                                                        <img
                                                            alt="Edit details"
                                                            className='pointer mb-1'
                                                            src={EditIcon}
                                                            height="25"
                                                            id={`Edit_Fc_Vessel_Machinery_${index}`}
                                                            onMouseEnter={() => {
                                                                setEditHoverId(`Edit_Fc_Vessel_Machinery_${index}`)
                                                            }}
                                                            onMouseLeave={() => setEditHoverId(null)}
                                                            onClick={() => {
                                                                setOpenPopoverVesselMachinaryObject(vesselMachinery);
                                                                setSelectedMachinery(vesselMachinery);
                                                                setEditFuelConsumerGroup(true);
                                                                setEditHoverId(null);
                                                                setDeletePopOverState(false)
                                                            }}
                                                        />
                                                    </button>
                                                    <img
                                                        src={isConfigurationButtonDisabled(vessel) ? DisabledDeleteIcon : DeleteIcon}
                                                        alt="Delete"
                                                        height="24"
                                                        id={`Delete_Fc_Vessel_Machinery_${index}`}
                                                        onMouseEnter={() => {
                                                            setHoverId(`Delete_Fc_Vessel_Machinery_${index}`)
                                                            setOpenPopoverVesselMachinaryObject(vesselMachinery);
                                                        }}
                                                        onMouseLeave={() => setHoverId(null)}
                                                        onClick={() => {
                                                            if (isConfigurationButtonDisabled(vessel)) return; // Prevent click when disabled
                                                            setDeletePopOverState(true);
                                                            setOpenPopoverVesselMachinaryObject(vesselMachinery);
                                                            setOpenPopoverIndex(index);
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4} className="text-center">
                                            <Message
                                                type='warning'
                                                message="No machineries configured for this vessel"
                                                width='40rem' />
                                        </td>
                                    </tr>
                                )}
                                {editFuelConsumerGroup && (
                                    <PopUp
                                        state={editFuelConsumerGroup}
                                        setState={setEditFuelConsumerGroup}
                                        body={
                                            <EditFuelConsumerGroup
                                                groupName={selectedMachinery.vessel_machinery_fc_group_name}
                                                vesselMachinery={selectedMachinery}
                                                vesselMachineriesList={vesselMachineriesList}
                                                editConsumerGroup={editFuelConsumerGroup}
                                                setEditFuelConsumerGroup={setEditFuelConsumerGroup}
                                                editPutURL={fcGroupURL}
                                                refreshVesselMachineries={refreshVesselMachineries}
                                                setRefreshVesselMachineries={setRefreshVesselMachineries}
                                                state={editFuelConsumerGroup}
                                                setState={setEditFuelConsumerGroup}
                                            />
                                        }
                                        title={`Edit fuel consumer group`}
                                        size="lg"
                                    />
                                )}
                                {deletePopOverState === true && openPopoverVesselMachinaryObject &&
                                    (<PopOver
                                        target={`Delete_Fc_Vessel_Machinery_${openPopoverIndex}`}
                                        handleClick={async () => {
                                            handleDelete(openPopoverVesselMachinaryObject);
                                            setRefreshForm(!refreshForm);
                                        }}
                                        message={`Are you sure you want to delete this group`}
                                        state={deletePopOverState}
                                        setState={setDeletePopOverState}
                                    />)
                                }
                                {hoverId !== null &&
                                    <ToolTip
                                        target={hoverId}
                                        isOpen={hoverId !== null}
                                        message={`Delete ${openPopoverVesselMachinaryObject?.vessel_machinery_fc_group_name} Group?`}
                                    />}
                                {hoverEditId !== null &&
                                    <ToolTip
                                        target={hoverEditId}
                                        isOpen={hoverEditId !== null}
                                        message={`Edit ${openPopoverVesselMachinaryObject?.vessel_machinery_fc_group_name} Group?`}
                                    />}
                            </tbody>
                        </table>
                        <p> - Add to the list, machinery which are fuel consumers.</p>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default FuelConsumer